var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tooltip',{attrs:{"placement":"top"}},[_c('div',{style:({maxWidth: '400px',maxHeight: '300px', overflow: 'auto'}),attrs:{"slot":"content"},slot:"content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.msg)}})]),_c('i',{staticClass:"el-icon-question",staticStyle:{"cursor":"pointer","margin-left":"3px"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }